import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { useDispatch } from "react-redux";
import { confirmAppointmentAdmin, getReturnedValue } from "../utils/fetcher";
import Patient from "./Patient";

export default function InscriptionAdmin() {
  const [value, setValue] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [load, setLoad] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  async function handleChange(val) {
    setLoad(true);
    const response = await fetch(
      `https://dev.alaxione.fr/ajax/recherche_fiche_patient_auto_complete.php?bypassidentcentre=${getReturnedValue(
        "idc"
      )}&term=${val}`
    );
    //await sleep(1e3);
    const json = await response.json();
    setOptions(json.success === "nop" ? [] : json);
    setLoad(false);
  }

  const handleSelect = val => {
    //dispatch(getDetailPatient(value.value));
    dispatch(confirmAppointmentAdmin(val));
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  return (
    <div className="wrap-form-patient">
      <div className="d-flex">
        <div className="wrap-autocomplete">
          <Autocomplete
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            onInputChange={(event, newInputValue) =>
              handleChange(newInputValue)
            }
            //getOptionSelected={(option, val) => {if (val === value) handleSelect(option, val)}}
            getOptionSelected={(option, { multiple, value }) => {
              if (!multiple && option.value === value) {
                /*
                 * PROPOSAL for single selection, be able to provide own logic.
                 */
                handleSelect(value);
                return option.value === value;
              }

              return false;
            }}
            id="asynchronous-demo"
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            getOptionLabel={option => option.label}
            options={options}
            loading={load}
            noOptionsText="Aucun patient trouvé"
            renderInput={params => (
              <TextField
                {...params}
                label="Nom du patient"
                fullWidth
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {load ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  )
                }}
              />
            )}
          />
        </div>
        <Fab color="primary" aria-label="add" onClick={toggleForm}>
          {showForm ? <RemoveIcon /> : <AddIcon />}
        </Fab>
      </div>
      {showForm && <Patient />}
    </div>
  );
}
